/* SETTINGS */
export const SET_SETTING = "SET_SETTING";
export const SET_ALL_SETTINGS = "SET_ALL_SETTINGS";

export const SET_SETTING_SUCCESS = "SET_SETTING_SUCCESS";
export const SET_SETTING_FAIL = "SET_SETTING_FAIL";
